import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-30330714"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = ["src"];
var _hoisted_2 = ["src"];
var _hoisted_3 = {
  key: 1
};
var _hoisted_4 = {
  "class": "title"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", null, "show", -1);
});
var _hoisted_6 = {
  "class": "description"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("b", null, "see or read something", -1);
});
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "sub"
  }, "A fun and super powerful feature!", -1);
});
var _hoisted_9 = {
  "for": "image-input",
  "class": "buttonAction"
};
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "Select Image", -1);
});
var _hoisted_11 = {
  key: 2,
  "class": "quick"
};
var _hoisted_12 = {
  key: 3,
  "class": "idealist"
};
var _hoisted_13 = /*#__PURE__*/_createStaticVNode("<li class=\"idealist__item\" data-v-30330714> Take photos of work or homework assignments to discuss ideas, solutions or simply to read something to you </li><li class=\"idealist__item\" data-v-30330714> Take pictures of hard to read handwriting to decypher what it says </li><li class=\"idealist__item\" data-v-30330714> Read a recipe out loud to you or ask for help with how to use the recipe with more detail </li><li class=\"idealist__item\" data-v-30330714> Ask questions about product labels or ask it to summarize it for you </li><li class=\"idealist__item\" data-v-30330714> Ask to translate text to a foreign language or a foreign language to your native </li><li class=\"idealist__item\" data-v-30330714> Show the AIVitars well know landmarks ask questions about the history and more. </li><li class=\"idealist__item\" data-v-30330714> Take a photo of a piece of art to get a detailed analysis of its composition, symbolism, and historical context </li><li class=\"idealist__item\" data-v-30330714> Show AIVitars scientific diagrams or charts to have it explained in detail or create code from mathamatical formulas </li><li class=\"idealist__item\" data-v-30330714> Have it guess the ages of people in a photo or breed of a dog </li><li class=\"idealist__item\" data-v-30330714> Show them a plant or flower to get a description of its species, origin, or even the instructions on how to care for them </li>", 10);
var _hoisted_23 = [_hoisted_13];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _$data$selectedAvatar, _$data$selectedAvatar2, _$data$selectedAvatar3, _$data$selectedAvatar4, _$data$selectedAvatar5;
  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  return _openBlock(), _createElementBlock("div", {
    "class": _normalizeClass({
      ImageUploadComponent: true,
      noBackground: _ctx.$store.state.photo
    })
  }, [_ctx.$store.state.photo && !_ctx.$store.state.smallPhoto ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    "class": "CameraComponent__max",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.$store.commit('minimizePhoto');
    })
  }, [_createElementVNode("img", {
    "class": "photo__max",
    src: _ctx.$store.state.photo,
    alt: "Captured Image"
  }, null, 8, _hoisted_1), _createElementVNode("button", {
    "class": "buttonAction",
    onClick: _cache[0] || (_cache[0] = function () {
      return $options.clearPhoto && $options.clearPhoto.apply($options, arguments);
    })
  }, "Stop using this image")])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", {
    "class": "CameraComponent__min",
    style: _normalizeStyle({
      top: "".concat(_ctx.y, "px"),
      left: "".concat(_ctx.x, "px")
    }),
    onMousedown: _cache[2] || (_cache[2] = function () {
      return _ctx.startDrag && _ctx.startDrag.apply(_ctx, arguments);
    }),
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return _ctx.$store.commit('maximizePhoto');
    })
  }, [_createElementVNode("img", {
    "class": "photo__min",
    src: _ctx.$store.state.photo,
    alt: "Captured Image"
  }, null, 8, _hoisted_2)], 36), [[_vShow, _ctx.$store.state.photo && _ctx.$store.state.smallPhoto]]), !_ctx.$store.state.photo ? (_openBlock(), _createElementBlock("div", _hoisted_3, [!_ctx.$store.state.photo || _ctx.$store.state.photo && !_ctx.$store.state.smallPhoto ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
    key: 0,
    icon: ['fa', 'times'],
    "class": "closeButton",
    onClick: _cache[4] || (_cache[4] = function ($event) {
      _ctx.$store.commit('updateShowImageUploader', false);
      _ctx.$store.commit('updatePhoto', null);
    })
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createTextVNode("Want to "), _hoisted_5, _createTextVNode(" " + _toDisplayString(_ctx.$store.state.avatar) + " something?", 1)]), _createElementVNode("div", _hoisted_6, [_createTextVNode(" If you want "), _createElementVNode("b", null, _toDisplayString(_ctx.$store.state.avatar), 1), _createTextVNode(" to "), _hoisted_7, _createTextVNode(", select a photo to share with " + _toDisplayString((_$data$selectedAvatar = $data.selectedAvatar) === null || _$data$selectedAvatar === void 0 ? void 0 : _$data$selectedAvatar.pronoun2) + ". Then, you'll be able to have conversations about the image, ask " + _toDisplayString((_$data$selectedAvatar2 = $data.selectedAvatar) === null || _$data$selectedAvatar2 === void 0 ? void 0 : _$data$selectedAvatar2.pronoun2) + " questions and get relevant feedback from " + _toDisplayString((_$data$selectedAvatar3 = $data.selectedAvatar) === null || _$data$selectedAvatar3 === void 0 ? void 0 : _$data$selectedAvatar3.pronoun2) + ". This is also gives " + _toDisplayString((_$data$selectedAvatar4 = $data.selectedAvatar) === null || _$data$selectedAvatar4 === void 0 ? void 0 : _$data$selectedAvatar4.pronoun2) + " the ability to read too! " + _toDisplayString((_$data$selectedAvatar5 = $data.selectedAvatar) === null || _$data$selectedAvatar5 === void 0 ? void 0 : _$data$selectedAvatar5.pronoun) + " can read text, whether printed or hand written. Check the examples below for more ideas on how to use this feature. ", 1)]), _hoisted_8, _createElementVNode("label", _hoisted_9, [_createVNode(_component_font_awesome_icon, {
    icon: ['fa', 'image'],
    "class": "iconImage"
  }), _hoisted_10, _createElementVNode("input", {
    type: "file",
    accept: "image/*",
    id: "image-input",
    onChange: _cache[5] || (_cache[5] = function () {
      return $options.handleImageSelect && $options.handleImageSelect.apply($options, arguments);
    }),
    hidden: ""
  }, null, 32)]), !$data.seeIdeas ? (_openBlock(), _createElementBlock("button", {
    key: 1,
    "class": "seeExamples",
    onClick: _cache[6] || (_cache[6] = function ($event) {
      return $data.seeIdeas = true;
    })
  }, " Show Examples ")) : _createCommentVNode("", true), $data.seeIdeas ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Here's some ideas to get you started:")) : _createCommentVNode("", true), $data.seeIdeas ? (_openBlock(), _createElementBlock("ul", _hoisted_12, _hoisted_23)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 2);
}